import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useAuthStore = defineStore(
  'auth',
  () => {
    const accessToken = ref(null);
    const role = ref(null);
    const tenantId = ref(null);
    const username = ref(null);
    const displayName = ref(null);
    // 登入者的人員姓名、代號與 tenantSeq（來自 /api/staff/me）
    const staffName = ref(null);
    const staffSerial = ref(null);
    const staffTenantSeq = ref(null);

    function setAccessToken(token) {
      accessToken.value = token;
    }

    function setRole(value) {
      role.value = value;
    }

    function setUserInfo(data) {
      tenantId.value = data.tenantId;
      username.value = data.username;
      displayName.value = data.displayName;
    }

    function setStaffInfo(data) {
      staffName.value = data?.name ?? null;
      staffSerial.value = data?.serial ?? null;
      staffTenantSeq.value = data?.tenantSeq ?? null;
    }

    function clearAccessToken() {
      accessToken.value = null;
      role.value = null;
      tenantId.value = null;
      username.value = null;
      displayName.value = null;
      staffName.value = null;
      staffSerial.value = null;
      staffTenantSeq.value = null;
    }

    return {
      accessToken,
      role,
      tenantId,
      username,
      displayName,
      staffName,
      staffSerial,
      staffTenantSeq,
      setAccessToken,
      setRole,
      setUserInfo,
      setStaffInfo,
      clearAccessToken,
    };
  },
  {
    persist: {
      pick: [
        'tenantId',
        'username',
        'displayName',
        'staffName',
        'staffSerial',
        'staffTenantSeq',
      ],
    },
  },
);
